import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TextAndImagesList.css';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import PDFViewerListModal from './Modals/PDFViewer/PDFViewerListModal';

function PDFViewerList({ curriculum, setCurriculum, clCardItem, setClCardItem, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="TILST" onClick={() => setIsOpen(true)}>
        <div className="TILST_A1">
          <FontAwesomeIcon icon={faNewspaper} />
        </div>
        <div className="TILST_A2">
          PDF Viewer
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <PDFViewerListModal curriculum={curriculum} setCurriculum={setCurriculum} clCardItem={clCardItem} setClCardItem={setClCardItem} lessonParent={lessonParent} isUploadingViaApi={isUploadingViaApi} setIsUploadingViaApi={setIsUploadingViaApi} />
      </Modal>
    </div>
  );
}

export default PDFViewerList;
